export default function QuickAccessTitleSplit(title) {
  const splitedTitle = title.split(" ") || [];
  const firstWord = splitedTitle.shift(" ");
  const restTitle = splitedTitle.join(" ");
  return [firstWord, restTitle];
}
